import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

/** This is leftover from ex developer. To refactor */
export const voucherErrorMessage = createSelector(
    onlineOrderState,
    onlineOrder => [(onlineOrder.voucherRequest.error?.error?.Message || '')]
);
